<header class="banner">
  <ng-container *ngIf="isLogoClickable; else nonClickableLogo">
    <a href="javascript:void(0)" (click)="goToHome()" class="logo-link" aria-label="Go to Inspera Originality home">
      <img class="logo" src="../../../../../../assets/report_v2/inspera_originality.svg" alt="Inspera Originality logo">
    </a>
  </ng-container>
  <ng-template #nonClickableLogo>
    <div class="logo-link">
      <img class="logo" src="../../../../../../assets/report_v2/inspera_originality.svg" alt="Inspera Originality logo">
    </div>
  </ng-template>
  <section>
    <div class="banner_menu_container submission_details" [class.menu-open]="activeMenuBar['submissionDetails']"
      data-menu-bar-key="submissionDetails" appCloseMenu>
      <button #detailsTriggerBtn class="banner_options_option d-flex" (click)="toggleMenuBar('submissionDetails', $event)"
        aria-label="Document Information" title="View Submission details"
        [attr.aria-expanded]="activeMenuBar['submissionDetails']" aria-haspopup="dialog">
        <img src="../../../../../../assets/report_v2/submission_details.svg" alt="document">
        <p class="fontColor">{{ 'new_entries.details' | translate }}</p>
      </button>
      <div class="dropdown menubar article" role="dialog" aria-label="Submission details" cdkTrapFocus>
        <div class="menubar-head">
          <h2>{{ 'new_entries.submission_details' | translate }}</h2>
          <button  #closeSubmissionDetails aria-label="Close" class="close-menubar" (click)="closeMenuBar('submissionDetails', $event)">
            <img src="../../../../../../assets/report_v2/close_big.svg" alt="Close submission details">
          </button>
        </div>
        <div class="menubar-body" role="presentation">
          <div>
            <h3>{{ 'general.table.name' | translate }}</h3>
            <p>{{ bannerDetails.title }}</p>
          </div>
          <div>
            <h3>{{ 'general.table.document_id' | translate }}</h3>
            <p>{{ bannerDetails.documentId }}</p>
          </div>
          <div>
            <h3>{{ 'report.document_language' | translate }}</h3>
            <p>{{ getLanguageName(bannerDetails.original_language) }}</p>
          </div>
          <div *ngIf="bannerDetails.translated_language && bannerDetails.translated_language.length !== 2">
            <h3>{{ 'app.upload.translated_language' | translate }}</h3>
            <p>{{ getLanguageName(bannerDetails.translated_language) }}</p>
          </div>
          <div>
            <h3>{{ 'new_entries.ai_authorship_analysis' | translate }}</h3>
            <ng-container *ngIf="bannerDetails.ai_authorship_analysis; else off">
              <p>{{ 'new_entries.on' | translate }}</p>
            </ng-container>
            <ng-template #off>
              <p>{{ 'new_entries.off' | translate }}</p>
            </ng-template>

            <!-- <p *ngIf="bannerDetails.ai_authorship_analysis; else off">On</p>
              <p #off>Off</p> -->
          </div>
          <div>
            <h3>{{ 'new_entries.file_size' | translate }}</h3>
            <p>{{ calculatedFileSize || formatBytes(bannerDetails.file_size) }}</p>
          </div>
          <div>
            <h3>{{ 'new_entries.word_count' | translate }}</h3>
            <p>{{ bannerDetails.word_count }}</p>
          </div>
          <div>
            <h3>{{ 'new_entries.page_count' | translate }}</h3>
            <p>{{ bannerDetails.page_count }}</p>
          </div>
          <div>
            <h3>{{'new_entries.view_count' | translate}}</h3>
            <p>{{ bannerDetails.view_count }}</p>
          </div>
          <div>
            <h3>{{ 'new_entries.table_date_and_time' | translate }}</h3>
            <p>{{ bannerDetails.createdAt | date:'dd.MM.yyyy | HH:mm' }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="banner_menu_container" [class.menu-open]="activeMenuBar['download']" data-menu-bar-key="download"
      appCloseMenu>
      <button #downloadTriggerBtn class="banner_options_option d-flex" (click)="openDownloadMenu($event)"
        aria-label="Downloads" [attr.aria-expanded]="activeMenuBar['download']"
        title="View documents available for download">
        <img src="../../../../../../assets/report_v2/download.svg" alt="Downloads">
        <p class="fontColor">{{ 'general.download' | translate }}</p>
      </button>
      <div id="download-menu" role="menu" class="dropdown" [attr.aria-hidden]="!activeMenuBar['download']"
        *ngIf="activeMenuBar['download']" cdkTrapFocus>
        <button role="menuitem"  aria-label="Download Offline Report"
          (click)="downloadPdfReport('crossplag')" (keydown)="onMenuKeydown($event, 'download')" (keydown.escape)="closeMenuBar('download', $event)" #focusOfflineReport>
          <p>{{ 'report.offline_report' | translate }}</p>
        </button>
        <button role="menuitem"  aria-label="Download Document File" (click)="downloadOriginalDocument()"
          (keydown)="onMenuKeydown($event, 'download')" (keydown.escape)="closeMenuBar('download', $event)">
          <p>{{ 'general.document_file' | translate }}</p>
        </button>
      </div>
    </div>
    <button  class="banner_options_option" (click)="openSettingsModal()" aria-label="Settings"
      aria-haspopup="dialog">
      <img src="../../../../../../assets/report_v2/settings.svg" alt="Settings">
      <p class="fontColor">{{ 'aria-labels.settings' | translate }}</p>
    </button>
    <button *ngIf="showExpandView"  (click)="openLink(newTab)" class="banner_options_option">
      <img src="../../../../../../assets/report_v2/open_in_another_tab.svg"
        alt="Open in another tab. Click in order to open the report in another tab.">
      <p class="fontColor" aria-label="Open in another tab name">{{ 'general.expand' | translate }}</p>
    </button>
    <button role="link"
      (click)="openLink('https://support.inspera.com/hc/en-us/categories/15848147005085-Inspera-Originality')"
      class="banner_options_option" aria-label="Help Center">
      <img src="../../../../../../assets/report_v2/help-circle.svg" alt="">
      <p class="fontColor">{{ 'general.help' | translate }}</p>
    </button>
  </section>
</header>